<template>
    <div class="panel panel-info" v-if="radio">
        <!-- Default panel contents -->
        <div class="panel-heading"><i class="fa fa-terminal" aria-hidden="true"></i> DADOS DE CONEXÃO - PPOE</div>
        <div class="panel-body">
            <div class="form-group">

                <div class="col-sm-3">
                    <label class="control-label">HABILITAR BURST:</label>
                    <true-false v-model="radio.burst"/>
                    <small>HABILITA BURST NO CLIENTE</small>
                </div>

                <div class="col-sm-6">
                    <label class="control-label">AUTENTICA APENAS COM O USUÁRIO:</label>
                    <true-false v-model="radio.auth_only_usuario"/>
                    <small>AUTENTICA APENAS COM O USUÁRIO SEM CHECAR A SENHA</small>
                </div>

                <div class="col-sm-2">
                    <label class="control-label">&nbsp;</label>
                    <div class="form-group">
                        <button @click="save()" class="btn btn-block btn-default btn-success" type="button">SALVAR</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
/* global swal */
import { Contratos } from "../../class/index";
import TrueFalse from "../../components/combo/true_false";
export default {
    components: {
        TrueFalse
    },
    props: {
        radio: {
            default: null
        },
        id: {
            default: null
        }
    },
    data() {
        return {
            type: "text",
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        change() {},
        save() {
            let json = {
                _id: this.id,
                auth_only_usuario: this.radio.auth_only_usuario,
                burst: this.radio.burst
            };
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o contrato?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => Contratos.updateLoginUsuario(json)
                }
            ]);
        }
    }
};
</script>
